export default function PlusIcon({ width = 14, height = 14, color = "#048604", className = "" }) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 9 10"
        fill="none"
        className={className}
      >
        <path
          d="M4.66016 1.32031V9"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.820312 5.16016H8.5"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  )
}
